<template>
    <div>
        <div class="page-title">Edit Account</div>
        <div class="page-box">
            <userAccountSettingFrom ref="ruleForm" :ruleForm="ruleForm"></userAccountSettingFrom>
            <el-button  type="warning" @click="onSubmit"> Submit </el-button>
        </div>
    </div>
</template>

<script>
    import {getUserDetail,editUser} from '@/api/admin/user'
    import userAccountSettingFrom from './components/userAccountSettingFrom.vue'
    export default {
        components:{userAccountSettingFrom},
        props:{
            id:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                ruleForm: {
                   
                },
            }
        },
        created(){
            this.getUserDetail()
        },
        methods:{
            onSubmit(){
                 this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.editUser()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
                
            },
            editUser(){
                if(this.ruleForm.roleId === this.roleClerkId){
                   this.ruleForm.assignApplicationFormType = this.ruleForm.assignApplicationFormType.join()
                }else {
                    this.ruleForm.assignApplicationFormType = null
                }
                editUser(this.id,this.ruleForm).then(()=>{
                    this.$message.success('Save success')
                    this.$router.push({path:`/admin/userAccountSetting`})
                })
            },
            getUserDetail(){
                getUserDetail(this.id).then((v)=>{
                     this.ruleForm = v.data
                     if(this.ruleForm.assignApplicationFormType !== null)
                     this.ruleForm.assignApplicationFormType = this.ruleForm.assignApplicationFormType.split(',')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    padding: 20px;
    background-color: #fff;
}
</style>